import Typography from "@mui/material/Typography";
import React, { useCallback } from "react";

interface PDFViewerProps {
  title?: string;
  fileUrl?: string;
  pages?: number[];
  className?: string;
}

const PDFViewer: React.FC<PDFViewerProps> = ({
  title,
  fileUrl,
  pages,
}: PDFViewerProps) => {
  const getUrl = useCallback(() => {
    let url = fileUrl;
    if (pages) {
      url = `${url}#page=${pages[0] + 1}`;
    }
    return url;
  }, [pages, fileUrl]);

  return fileUrl ? (
    <iframe
      title={title}
      src={getUrl()}
      className="overflow-auto"
      style={{
        border: "none",
        height: "100%",
        width: "100%",
      }}
    />
  ) : (
    <Typography className="text-gray-500">No PDF file provided</Typography>
  );
};

export default PDFViewer;
